export default __webpack_public_path__ + "3048a6b18e7027c104101a745160fe23.svg";